/** Session dismissal of the "profile is not complete" prompt. The value is the user id, never a token. */
export const PROFILE_PROMPT_DISMISSED_KEY = 'wijmobiel-profile-prompt-dismissed'

function readStorage(): Storage | null {
  try {
    return globalThis.sessionStorage
  } catch {
    return null
  }
}

export function isProfilePromptDismissed(userId: string): boolean {
  try {
    return readStorage()?.getItem(PROFILE_PROMPT_DISMISSED_KEY) === userId
  } catch {
    return false
  }
}

export function dismissProfilePrompt(userId: string): void {
  try {
    readStorage()?.setItem(PROFILE_PROMPT_DISMISSED_KEY, userId)
  } catch {
    // Private mode can reject sessionStorage. The prompt stays for this render only.
  }
}

export function clearProfilePromptDismissal(): void {
  try {
    readStorage()?.removeItem(PROFILE_PROMPT_DISMISSED_KEY)
  } catch {
    // Ignore a storage that cannot be cleared.
  }
}

/**
 * Self view, incomplete profile (missing required fields), and not the
 * legacy-consent case (`conditionsAgreed === true && conditionsAgreedAt === null`).
 * The stored pendingUserData flag is not a gate: the prompt follows the same
 * missing-fields rule as the "Gegevens ingevuld" step.
 * Hidden while the profile is still unknown, and after Later for this user.
 */
export function shouldShowProfilePrompt(input: {
  isAdminView: boolean
  missingRequiredFields: number
  conditionsAgreed: boolean | undefined
  conditionsAgreedAt: string | null | undefined
  profileKnown: boolean
  userId: string | undefined
}): boolean {
  if (input.isAdminView) return false
  if (!input.profileKnown) return false
  if (input.missingRequiredFields <= 0) return false
  if (input.conditionsAgreed === true && input.conditionsAgreedAt === null) return false
  if (!input.userId) return false
  if (isProfilePromptDismissed(input.userId)) return false

  return true
}
